// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { useState } from 'react';
import { PrimaryButton, Stack, Text } from '@fluentui/react';
import { FeedbackPopup } from 'components/Feedback/FeedbackDialog';

export const ErrorFallback = (): JSX.Element => {
  const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);

  return (
    <>
      <Stack
        verticalFill
        verticalAlign="center"
        horizontalAlign="center"
        tokens={{ childrenGap: '2rem' }}
        styles={{ root: { margin: '2rem' } }}
      >
        <Stack.Item>
          <Text variant="xLarge">Error - An uncaught exception occurred.</Text>
        </Stack.Item>
        <Stack.Item>
          <Stack horizontalAlign="center" tokens={{ childrenGap: '0.25rem' }}>
            <Text variant="mediumPlus" styles={{ root: { fontWeight: 'bold' } }}>
              Please note: You may still currently be connected to a call.
            </Text>
            <Text variant="mediumPlus">
              Optionally file a BRB report then please refresh this window to disconnect from any calls.
            </Text>
          </Stack>
        </Stack.Item>
        <Stack.Item>
          <Stack horizontal tokens={{ childrenGap: '1rem' }}>
            <PrimaryButton onClick={() => setShowFeedbackPopup(true)}>File BRB Report</PrimaryButton>
            <PrimaryButton onClick={refreshWindow}>Refresh Window</PrimaryButton>
          </Stack>
        </Stack.Item>
      </Stack>
      <FeedbackPopup
        onDismiss={() => setShowFeedbackPopup(false)}
        resetFields={() => {
          return;
        }}
        isOpen={showFeedbackPopup}
        defaultFields={{
          title: 'Uncaught exception',
          feedbackType: 'Others',
          comment: 'Please add below any information what was happening when this exception occurred.'
        }}
      />
    </>
  );
};

const refreshWindow = (): void => {
  window.location.reload();
};
